<template>
	<div id="appraisals-index"
		 class="app-home ui-styles"
		 :class="theme">

		<template class="view_container">
			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>
			<div class="master_view">
				<side-nav-bar :fileOpen="fileOpen" :fileNumber="appraisalfile.number"></side-nav-bar>
				<div class="app-container">
					<bar>
					</bar>
					<h1><span v-if="!appraisalfile.number">{{ $t('Edit') }} {{ $t('appraisal_file') }}</span><span
							v-else>{{ $t('File') }} {{ appraisalfile.number }}
					</span> <span v-if="appraisalfile.dirty">*</span></h1>
					<message
							v-if="appraisalfile.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<div class="datedata">
						<p class="small">{{ $t('Created') }}: {{ millis_to_time(appraisalfile.date_created) }}</p>
						<p class="small">{{ $t('Last_modified') }}: {{ millis_to_time(appraisalfile.date_modified)
							}}</p>
					</div>
					<div>
						<form class="bt-form">
							<div class="section-container">
								<h3>{{ $t('File_number') }}</h3>
								<div class="field-container">
									<div class="field__group">
										<label class="field__group__label">{{ $t('File_number') }}</label>
										<input class="field__group__input"
											   type="number"
											   spellcheck="false"
											   v-model="appraisalfile.number"
											   @input="set_appraisalfile_number">
									</div>
								</div>
							</div>
							<div class="section-container">
								<h3>{{ $t('Description') }}</h3>

								<div class="field-container">
									<div class="field__group">
										<label class="field__group__label">{{ $t('Appraisal_file_description')
											}}</label>
										<input class="field__group__input"
											   type="text"
											   spellcheck="false"
											   v-model="appraisalfile.description"
											   @input="set_appraisalfile_description">
									</div>
								</div>
							</div>

							<div class="form-section">
								<h3>{{ $t('Appraisal_quotes') }} {{ $t('contained_in_this_file') }}</h3>
								<div>
									<div @click.prevent="checkCreateNewAppraisalQuote"
										 style="width: fit-content; margin-left: auto">
										<icon-button icon="plus-circle" :text="new_appraisalquote_button_text"
													 icon_color="black"
													 text_color="black" border_color="lightgray"></icon-button>
									</div>
								</div>
								<div v-if="object_length(appraisalfile_appraisalquotes) > 0">
									<!--
									<div class="grid-row" layout="row top-stretch">
										<div class="grid-cell" layout="row">
											<input type="text" :placeholder="filter_placeholder" self="size-x1"
												   v-model="appraisalquote_table.filter"
												   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
												   data-step="9" data-position="top">
										</div>
									</div>
									-->
									<div class="grid-row" layout="row top-stretch">
										<div class="grid-cell">
											<paginator :source="object_to_array(appraisalfile_appraisalquotes)"
													   :page-size="10"
													   :filter="appraisalquote_table.filter"
													   data-intro="Use the paginator to page data for easier viewing"
													   data-step="10"
													   data-position="top">
												<template scope="page">
													<datatable id="data-table-appraisalquote"
															   :source="page.data"
															   :filterable="false"
															   :striped="appraisalquote_table.striped"
															   :editable="appraisalquote_table.editable"
															   :line-numbers="appraisalquote_table.lineNumbers">
														<datatable-column
																v-for="column in appraisalquote_table.columns"
																:id="column.id"
																:label="column.label"
																:width="column.width"
																:sortable="column.sortable"
																:groupable="column.groupable"
																:formatter="column.formatter">
														</datatable-column>
														<datatable-column id="actions-appraisalquote"
																		  :label="actions_text"
																		  :sortable="false"
																		  :groupable="false"></datatable-column>
														<template slot="status" scope="cell">
															<div v-if="cell.row['status']">
																<span v-if="currentLocale === 'ca'">
																	{{ cell.row['status'].name_ca }}</span>
																<span v-else-if="currentLocale === 'en'">
																	{{ cell.row['status'].name_en }}</span>
																<span v-else>{{ cell.row['status'].name_es }}</span>
															</div>
														</template>
														<template slot="send_to_bde" scope="cell">
															<!--{{ cell.row['send_to_bde'] }}-->
															<div v-if="cell.row['send_to_bde']">
															<span v-if="currentLocale === 'ca'">
																Sí
															</span>
																<span v-else-if="currentLocale === 'es'">Sí
															</span>
																<span v-else-if="currentLocale === 'en'">Yes</span>
															</div>
															<div v-else>
																No
															</div>
														</template>
														<template slot="actions-appraisalquote" scope="cell">
															<table class="actions-table">
																<tr>
																	<td><a @click="checkEditAppraisalQuote(cell.row)"
																		   style="cursor: pointer;" :title="edit_text">
																		<icon name="pencil" scale="1"
																			  color="gray"></icon>
																	</a></td>
																	<td><a @click="duplicateAppraisalQuote(cell.row)"
																		   style="cursor: pointer;"
																		   :title="duplicate_text">
																		<icon name="files-o" scale="1"
																			  color="gray"></icon>
																	</a></td>
																	<td><a @click="deleteAppraisalQuote(cell.row)"
																		   style="cursor: pointer;"
																		   :title="delete_text">
																		<icon name="trash-o" scale="1"
																			  color="gray"></icon>
																	</a></td>
																</tr>
															</table>


														</template>
													</datatable>
												</template>
											</paginator>
										</div>
									</div>
								</div>

							</div>
							<div class="form-section">
								<h3>{{ $t('Appraisal_invoices') }} {{ $t('contained_in_this_file_f') }}</h3>
								<div>
									<div @click.prevent="checkCreateNewAppraisalInvoice"
										 style="width: fit-content; margin-left: auto">
										<icon-button icon="plus-circle" :text="new_appraisalinvoice_button_text"
													 icon_color="black"
													 text_color="black" border_color="lightgray"></icon-button>
									</div>
								</div>
								<div v-if="object_length(appraisalfile_appraisalinvoices) > 0">
									<!--
									<div class="grid-row" layout="row top-stretch">
										<div class="grid-cell" layout="row">
											<input type="text" :placeholder="filter_placeholder" self="size-x1"
												   v-model="appraisalinvoice_table.filter"
												   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
												   data-step="9" data-position="top">
										</div>
									</div>
									-->
									<div class="grid-row" layout="row top-stretch">
										<div class="grid-cell">
											<paginator :source="object_to_array(appraisalfile_appraisalinvoices)"
													   :page-size="10"
													   :filter="appraisalinvoice_table.filter"
													   data-intro="Use the paginator to page data for easier viewing"
													   data-step="10"
													   data-position="top">
												<template scope="page">
													<datatable id="data-table-appraisalinvoice"
															   :source="page.data"
															   :filterable="false"
															   :striped="appraisalinvoice_table.striped"
															   :editable="appraisalinvoice_table.editable"
															   :line-numbers="appraisalinvoice_table.lineNumbers">
														<datatable-column
																v-for="column in appraisalinvoice_table.columns"
																:id="column.id"
																:label="column.label"
																:width="column.width"
																:sortable="column.sortable"
																:groupable="column.groupable"
																:formatter="column.formatter">
														</datatable-column>
														<datatable-column id="actions-appraisalinvoice"
																		  :label="actions_text"
																		  :sortable="false"
																		  :groupable="false"></datatable-column>
														<template slot="status" scope="cell">
															<div v-if="cell.row['status']">
																<span v-if="currentLocale === 'ca'">
																	{{ cell.row['status'].name_ca }}</span>
																<span v-else-if="currentLocale === 'en'">
																	{{ cell.row['status'].name_en }}</span>
																<span v-else>{{ cell.row['status'].name_es }}</span>
															</div>
														</template>
														<template slot="send_to_bde" scope="cell">
															<!--{{ cell.row['send_to_bde'] }}-->
															<div v-if="cell.row['send_to_bde']">
															<span v-if="currentLocale === 'ca'">
																Sí
															</span>
																<span v-else-if="currentLocale === 'es'">Sí
															</span>
																<span v-else-if="currentLocale === 'en'">Yes</span>
															</div>
															<div v-else>
																No
															</div>
														</template>
														<template slot="actions-appraisalinvoice" scope="cell">
															<table class="actions-table">
																<tr>
																	<td><a @click="checkEditAppraisalInvoice(cell.row)"
																		   style="cursor: pointer;" :title="edit_text">
																		<icon name="pencil" scale="1"
																			  color="gray"></icon>
																	</a></td>
																	<td><a @click="duplicateAppraisalInvoice(cell.row)"
																		   style="cursor: pointer;"
																		   :title="duplicate_text">
																		<icon name="files-o" scale="1"
																			  color="gray"></icon>
																	</a></td>
																	<td><a @click="deleteAppraisalInvoice(cell.row)"
																		   style="cursor: pointer;"
																		   :title="delete_text">
																		<icon name="trash-o" scale="1"
																			  color="gray"></icon>
																	</a></td>
																</tr>
															</table>


														</template>
													</datatable>
												</template>
											</paginator>
										</div>
									</div>
								</div>

							</div>
							<div class="form-section">
								<h3>{{ $t('Reports') }} {{ $t('contained_in_this_file') }}</h3>
								<div>
									<div @click.prevent="checkCreateNewAppraisalReport"
										 style="width: fit-content; margin-left: auto">
										<icon-button icon="plus-circle" :text="new_appraisalreport_button_text"
													 icon_color="black"
													 text_color="black" border_color="lightgray"></icon-button>
									</div>
								</div>
								<div v-if="object_length(appraisalfile_appraisalreports) > 0">
									<!--
									<div class="grid-row" layout="row top-stretch">
										<div class="grid-cell" layout="row">
											<input type="text" :placeholder="filter_placeholder" self="size-x1"
												   v-model="appraisalreport_table.filter"
												   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
												   data-step="9" data-position="top">
										</div>
									</div>
									-->
									<div class="grid-row" layout="row top-stretch">
										<div class="grid-cell">
											<paginator :source="object_to_array(appraisalfile_appraisalreports)"
													   :page-size="10"
													   :filter="appraisalreport_table.filter"
													   data-intro="Use the paginator to page data for easier viewing"
													   data-step="10"
													   data-position="top">
												<template scope="page">
													<datatable id="data-table-appraisalreport"
															   :source="page.data"
															   :filterable="false"
															   :striped="appraisalreport_table.striped"
															   :editable="appraisalreport_table.editable"
															   :line-numbers="appraisalreport_table.lineNumbers">
														<datatable-column
																v-for="column in appraisalreport_table.columns"
																:id="column.id"
																:label="column.label"
																:width="column.width"
																:sortable="column.sortable"
																:groupable="column.groupable"
																:formatter="column.formatter">
														</datatable-column>
														<datatable-column id="actions-appraisalreport"
																		  :label="actions_text"
																		  :sortable="false"
																		  :groupable="false"></datatable-column>
														<template slot="status" scope="cell">
															<div v-if="cell.row['status']">
																<span v-if="currentLocale === 'ca'">
																	{{ cell.row['status'].name_ca }}</span>
																<span v-else-if="currentLocale === 'en'">
																	{{ cell.row['status'].name_en }}</span>
																<span v-else>{{ cell.row['status'].name_es }}</span>
															</div>
														</template>
														<template slot="send_to_bde" scope="cell">
															<!--{{ cell.row['send_to_bde'] }}-->
															<div v-if="cell.row['send_to_bde']">
															<span v-if="currentLocale === 'ca'">
																Sí
															</span>
																<span v-else-if="currentLocale === 'es'">Sí
															</span>
																<span v-else-if="currentLocale === 'en'">Yes</span>
															</div>
															<div v-else>
																No
															</div>
														</template>
														<template slot="actions-appraisalreport" scope="cell">
															<table class="actions-table">
																<tr>
																	<td><a @click="checkEditAppraisalReport(cell.row)"
																		   style="cursor: pointer;" :title="edit_text">
																		<icon name="pencil" scale="1"
																			  color="gray"></icon>
																	</a></td>
																	<td><a @click="duplicateAppraisalReport(cell.row)"
																		   style="cursor: pointer;"
																		   :title="duplicate_text">
																		<icon name="files-o" scale="1"
																			  color="gray"></icon>
																	</a></td>
																	<td><a @click="deleteAppraisalReport(cell.row)"
																		   style="cursor: pointer;"
																		   :title="delete_text">
																		<icon name="trash-o" scale="1"
																			  color="gray"></icon>
																	</a></td>
																</tr>
															</table>


														</template>
													</datatable>
												</template>
											</paginator>
										</div>
									</div>
								</div>

							</div>


							<div>
								<hr>
							</div>
							<div>
								<div @click.prevent="onGoUp" style="width: fit-content; margin-left: auto">
									<icon-button icon="level-up" :text="goup_button_text"
												 icon_color="black"
												 text_color="black" border_color="lightgray"></icon-button>
								</div>
							</div>
							<div>
								<div @click.prevent="onSaveCurrentAppraisalFile({go_up: false})"
									 style="width: fit-content; margin-left: auto">
									<icon-button icon="floppy-o" :text="save_button_text" icon_color="white"
												 text_color="white" border_color="#006bc5"
												 background_color="#0087F8"></icon-button>
								</div>
							</div>
							<div>
								<div @click.prevent="onSaveCurrentAppraisalFile({go_up: true})"
									 style="width: fit-content; margin-left: auto">
									<icon-button icon="floppy-o" :text="save_and_go_up_button_text" icon_color="white"
												 text_color="white" border_color="#006bc5"
												 background_color="#0087F8"></icon-button>
								</div>
							</div>
							<message
									v-if="appraisalfile.dirty"
									:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
									border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
							</message>
						</form>
					</div>

<!--
					<bar>
					</bar>
					-->

				</div>
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import router from '../../../router'
    import { dateMixin, localStorageMixin, objectsMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import Message from '../../../components/Message.vue'
    import SuccessMessage from '../../../components/SuccessMessage.vue'

    import honorificTitleOptions from '../../../options/honorific_titles'
    import personTypeOptions from '../../../options/person_types'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    export default {
        name: 'appraisalfile-editor',

        mixins: [
            dateMixin,
            localStorageMixin,
            objectsMixin
        ],

        data: () => ({
            master_loading: false,
            fileOpen: true,
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            new_appraisalreport_button_text: Vue.i18n.translate('Add_appraisal_report'),
            new_appraisalquote_button_text: Vue.i18n.translate('Add_appraisal_quote'),
            new_appraisalinvoice_button_text: Vue.i18n.translate('Add_appraisal_invoice'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goback_button_text: Vue.i18n.translate('Go_back') + ' ' + Vue.i18n.translate('without_saving'),
            goup_button_text: Vue.i18n.translate('Go_up') + ' ' + Vue.i18n.translate('without_saving'),
            save_button_text: Vue.i18n.translate('Save'),
            save_and_go_up_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_up'),
            cad_ref_error_text_01: Vue.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: Vue.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: Vue.i18n.translate('Actions'),
            duplicate_text: Vue.i18n.translate('Duplicate'),
            edit_text: Vue.i18n.translate('Edit'),
            delete_text: Vue.i18n.translate('Delete'),
            value: null,
            ms_placeholder: Vue.i18n.translate('Pick_an_option'),
            error: null,
            success_message: null,
            honorificTitleOptions,
            personTypeOptions,
            appraisalreport_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'number',
                        label: Vue.i18n.translate('Report_number'),
                        width: 14,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'version',
                        label: Vue.i18n.translate('Version'),
                        width: 8,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'description',
                        label: Vue.i18n.translate('Description'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'status',
                        label: Vue.i18n.translate('Status'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'send_to_bde',
                        label: 'BdE',
                        width: 8,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'date_modified',
                        label: Vue.i18n.translate('Last_modified'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return moment(value).format('DD/MM/YYYY HH:mm:ss')
                        }
                    }
                ],
                selected: []
            },
            appraisalquote_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'number',
                        label: Vue.i18n.translate('Quote_number'),
                        width: 14,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'version',
                        label: Vue.i18n.translate('Version'),
                        width: 8,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'description',
                        label: Vue.i18n.translate('Description'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'status',
                        label: Vue.i18n.translate('Status'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'date_modified',
                        label: Vue.i18n.translate('Last_modified'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return moment(value).format('DD/MM/YYYY HH:mm:ss')
                        }
                    }
                ],
                selected: []
            },
            appraisalinvoice_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'number',
                        label: Vue.i18n.translate('Invoice_number'),
                        width: 14,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'version',
                        label: Vue.i18n.translate('Version'),
                        width: 8,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'description',
                        label: Vue.i18n.translate('Description'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'status',
                        label: Vue.i18n.translate('Status'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'date_modified',
                        label: Vue.i18n.translate('Last_modified'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return moment(value).format('DD/MM/YYYY HH:mm:ss')
                        }
                    }
                ],
                selected: []
            }
        }),

        created () {

        },

        components: {
            Bar,
            Message,
            SuccessMessage,
            IconButton,
            Spinner,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator,
            SideNavBar
        },

        computed: {
            ...mapGetters([
                'theme',
                'currentLocale',
                'appraisalreport',
                'appraisalquote',
                'appraisalinvoice',
                'appraisalfile',
                'appraisalfile_appraisalreports',
                'appraisalfile_appraisalquotes',
                'appraisalfile_appraisalinvoices',
                'stats_current'
            ])
        },

        created () {
            this.FETCH_APPRAISALFILE_APPRAISALREPORTS({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalreports'})
                .then(() => {
                    this.FETCH_APPRAISALFILE_APPRAISALQUOTES({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalquotes'})
                        .then(() => {
                            this.FETCH_APPRAISALFILE_APPRAISALINVOICES({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalinvoices'})
                                .then(() => {
                                    this.FETCH_STATS_CURRENT({})
                                        .then(() => {
                                            this.master_loading = false
                                        })
                                })
                        })
                })
        },

        methods: {
            ...mapActions(
                [
                    'CREATE_NEW_APPRAISALREPORT',
                    'DELETE_APPRAISALREPORT',
                    'FETCH_APPRAISALFILE_APPRAISALREPORTS',
                    'RESET_APPRAISALREPORT',
                    'GET_APPRAISALREPORT',
                    'SET_APPRAISALREPORT',

                    'CREATE_NEW_APPRAISALQUOTE',
                    'DELETE_APPRAISALQUOTE',
                    'FETCH_APPRAISALFILE_APPRAISALQUOTES',
                    'RESET_APPRAISALQUOTE',
                    'GET_APPRAISALQUOTE',
                    'SET_APPRAISALQUOTE',

                    'CREATE_NEW_APPRAISALINVOICE',
                    'DELETE_APPRAISALINVOICE',
                    'FETCH_APPRAISALFILE_APPRAISALINVOICES',
                    'RESET_APPRAISALINVOICE',
                    'GET_APPRAISALINVOICE',
                    'SET_APPRAISALINVOICE',

                    'SET_APPRAISALFILE_DESCRIPTION',
                    'SET_APPRAISALFILE_NUMBER',
                    'UPDATE_APPRAISALFILE',
                    'UPDATE_APPRAISALREPORT',

                    'UPDATE_APPRAISALQUOTE',

                    'UPDATE_APPRAISALINVOICE',
                    'SET_VALUE',
                    'FETCH_STATS_CURRENT'
                ]),

            set_appraisalfile_description: _.debounce(function (e) {
                this.SET_APPRAISALFILE_DESCRIPTION(e.target.value)
            }, 1000),
            set_appraisalfile_number: _.debounce(function (e) {
                this.SET_APPRAISALFILE_NUMBER(Number(e.target.value))
            }, 1000),

            onCreateNewAppraisalReport: function () {

                this.master_loading = true
                // console.log('hey')
                // console.log('appraisalfile: ')
                // console.log(this.appraisalfile)

                const appraisalreports_size = _.size(this.appraisalfile_appraisalreports)

                let new_reportnumber = 1
                let new_versionnumber = 1

                if (appraisalreports_size > 0) {

                    const reportnumbers = _.reverse(_.map(this.appraisalfile_appraisalreports, 'number'))
                    new_reportnumber = reportnumbers[0] + 1
                    // console.log('map reportnumbers: ')
                    // console.log(reportnumbers)

                }

                let filenumber = ''
                filenumber = this.appraisalfile.number

                let s = new_reportnumber + ''
                while (s.length < 2) s = '0' + s
                let reportnumber = s

                let p = new_versionnumber + ''
                while (p.length < 2) p = '0' + p
                let reportversion = p

                let fullnumber = filenumber + '/' + reportnumber + '/' + reportversion

                this.RESET_APPRAISALREPORT().then((res) => {
                    this.CREATE_NEW_APPRAISALREPORT({
                        path: 'appraisalreports' + '/',
                        parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
                        file_id: this.appraisalfile.id,
                        number: new_reportnumber,
                        version: new_versionnumber,
                        full_number: fullnumber
                    }).then((res) => {
                        this.$router.push({name: 'appraisalreport-editor', query: {id: this.appraisalreport.id}})
                    })
                })

            },
            checkCreateNewAppraisalReport: function () {
                this.onSaveCurrentAppraisalFile({go_up: false})
                /*
                if(this.appraisalfile.dirty){
                    const result = window.confirm(Vue.i18n.translate('There_are_unsaved_changes') + '. ' + Vue.i18n.translate('Unsaved_data_will_be_lost') + '. ' + Vue.i18n.translate('Continue_q'))
                    if (result) {
                        this.onCreateNewAppraisalReport()
                    }
                }else{
                    this.onCreateNewAppraisalReport()
                }*/
                // save appraisalfile before creating new appraisalreport
                this.UPDATE_APPRAISALFILE({
                    object: this.appraisalfile,
                    path: 'appraisalfiles' + '/' + this.appraisalfile.id
                }).then((res) => {
                    this.onCreateNewAppraisalReport()
                })
            },
            duplicateAppraisalReport: function (entity) {

                this.master_loading = true

                const new_versionnumber = entity.version + 1

                this.RESET_APPRAISALREPORT().then((res) => {
                    this.CREATE_NEW_APPRAISALREPORT({
                        path: 'appraisalreports' + '/',
                        parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
                        file_id: this.appraisalfile.id,
                        number: entity.number,
                        version: new_versionnumber
                    }).then((res) => {

                        console.log('duplicateAppraisalReport then res:')
                        console.log(res)

                        const new_object_id = res.key
                        const new_object_version = new_versionnumber

                        this.GET_APPRAISALREPORT({path: 'appraisalreports' + '/' + entity.id}).then((res) => {

                            console.log(' *^*^*^*^*^*^*^*^*^*^get appraisal report res: ')
                            console.log(res)

                            let new_object = res
                            new_object.id = new_object_id
                            new_object.version = new_object_version

                            this.UPDATE_APPRAISALREPORT({
                                object: new_object,
                                path: 'appraisalreports/',
                                parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
                                key: new_object_id
                            }).then((res) => {

                                this.master_loading = true
                                this.FETCH_APPRAISALFILE_APPRAISALREPORTS({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalreports'})
                                    .then(() => {
                                        this.master_loading = false
                                    })

                            })

                        })

                    })
                })

            },
            onCreateNewAppraisalQuote: function () {

                this.master_loading = true
                // console.log('hey')
                // console.log('appraisalfile: ')
                // console.log(this.appraisalfile)

                const appraisalquotes_size = _.size(this.appraisalfile_appraisalquotes)

                let new_quotenumber = 1
                let new_versionnumber = 1

                if (appraisalquotes_size > 0) {

                    const quotenumbers = _.reverse(_.map(this.appraisalfile_appraisalquotes, 'number'))
                    new_quotenumber = quotenumbers[0] + 1
                    // console.log('map quotenumbers: ')
                    // console.log(quotenumbers)

                }

                let filenumber = ''
                filenumber = this.appraisalfile.number

                let s = new_quotenumber + ''
                while (s.length < 2) s = '0' + s
                let quotenumber = s

                let p = new_versionnumber + ''
                while (p.length < 2) p = '0' + p
                let quoteversion = p

                let fullnumber = filenumber + '/' + quotenumber + '/' + quoteversion

                this.RESET_APPRAISALQUOTE().then((res) => {
                    this.CREATE_NEW_APPRAISALQUOTE({
                        path: 'appraisalquotes' + '/',
                        parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalquotes' + '/',
                        file_id: this.appraisalfile.id,
                        number: new_quotenumber,
                        version: new_versionnumber,
                        full_number: fullnumber
                    }).then((res) => {
                        this.$router.push({name: 'appraisalquote-editor', query: {id: this.appraisalquote.id}})
                    })
                })

            },
            checkCreateNewAppraisalQuote: function () {
                this.onSaveCurrentAppraisalFile({go_up: false})
                this.onCreateNewAppraisalQuote()

                /*
                if (this.appraisalfile.dirty) {
                    const result = window.confirm(Vue.i18n.translate('There_are_unsaved_changes') + '. ' + Vue.i18n.translate('Unsaved_data_will_be_lost') + '. ' + Vue.i18n.translate('Continue_q'))
                    if (result) {
                        this.onCreateNewAppraisalQuote()
                    }
                } else {
                    this.onCreateNewAppraisalQuote()
                }
                */
            },
            duplicateAppraisalQuote: function (entity) {

                this.master_loading = true

                const new_versionnumber = entity.version + 1

                let filenumber = ''
                filenumber = this.appraisalfile.number

                let s = this.appraisalquote.number + ''
                while (s.length < 2) s = '0' + s
                let quotenumber = s

                let p = new_versionnumber + ''
                while (p.length < 2) p = '0' + p
                let quoteversion = p

                let fullnumber = filenumber + '/' + quotenumber + '/' + quoteversion

                this.RESET_APPRAISALQUOTE().then((res) => {
                    this.CREATE_NEW_APPRAISALQUOTE({
                        path: 'appraisalquotes' + '/',
                        parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalquotes' + '/',
                        file_id: this.appraisalfile.id,
                        number: entity.number,
                        version: new_versionnumber,
                        full_number: fullnumber
                    }).then((res) => {

                        console.log('duplicateAppraisalQuote then res:')
                        console.log(res)

                        const new_object_id = res.key
                        const new_object_version = new_versionnumber

                        this.GET_APPRAISALQUOTE({path: 'appraisalquotes' + '/' + entity.id}).then((res) => {

                            console.log(' *^*^*^*^*^*^*^*^*^*^get appraisal quote res: ')
                            console.log(res)

                            let new_object = res
                            new_object.id = new_object_id
                            new_object.version = new_object_version

                            this.UPDATE_APPRAISALQUOTE({
                                object: new_object,
                                path: 'appraisalquotes/',
                                parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalquotes' + '/',
                                key: new_object_id
                            }).then((res) => {

                                this.master_loading = true
                                this.FETCH_APPRAISALFILE_APPRAISALQUOTES({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalquotes'})
                                    .then(() => {
                                        this.master_loading = false
                                    })

                            })

                        })

                    })
                })

            },
            onCreateNewAppraisalInvoice: function () {

                this.master_loading = true
                // console.log('hey')
                // console.log('appraisalfile: ')
                // console.log(this.appraisalfile)

                const appraisalinvoices_size = _.size(this.appraisalfile_appraisalinvoices)

                let stats_current = this.stats_current

                let fiscal_number = 0

                if (!stats_current) {
                    let pre = moment().format('YY')
                    fiscal_number = pre.toString() + '0000'
                    fiscal_number = Number(fiscal_number)
                    stats_current = {
                        'last_invoice_fiscal_number': 0
                    }
                }

                fiscal_number = stats_current.last_invoice_fiscal_number + 1

				console.log('new fiscal number: ')
				console.log(fiscal_number)

                stats_current['last_invoice_fiscal_number'] = fiscal_number

                console.log('stats_current: ')
				console.log(stats_current)

                let new_invoicenumber = 1
                let new_versionnumber = 1

                if (appraisalinvoices_size > 0) {

                    const invoicenumbers = _.reverse(_.map(this.appraisalfile_appraisalinvoices, 'number'))
                    new_invoicenumber = invoicenumbers[0] + 1
                    // console.log('map invoicenumbers: ')
                    // console.log(invoicenumbers)

                }

                let filenumber = ''
                filenumber = this.appraisalfile.number

                let s = new_invoicenumber + ''
                while (s.length < 2) s = '0' + s
                let invoicenumber = s

                let p = new_versionnumber + ''
                while (p.length < 2) p = '0' + p
                let invoiceversion = p

                let fullnumber = filenumber + '/' + invoicenumber + '/' + invoiceversion

                this.RESET_APPRAISALINVOICE().then((res) => {
                    this.CREATE_NEW_APPRAISALINVOICE({
                        path: 'appraisalinvoices' + '/',
                        parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalinvoices' + '/',
                        file_id: this.appraisalfile.id,
                        number: new_invoicenumber,
                        version: new_versionnumber,
                        full_number: fullnumber,
                        fiscal_number: fiscal_number
                    }).then((res) => {
                        this.SET_VALUE({
                            path: 'stats/current',
                            object: stats_current
                        })
                        this.$router.push({
                            name: 'appraisalinvoice-editor',
                            query: {id: this.appraisalinvoice.id, file_id: this.appraisalfile.id}
                        })
                    })
                })

            },
            checkCreateNewAppraisalInvoice: function () {
                this.onSaveCurrentAppraisalFile({go_up: false})
                this.onCreateNewAppraisalInvoice()
				/*

                if (this.appraisalfile.dirty) {
                    const result = window.confirm(Vue.i18n.translate('There_are_unsaved_changes') + '. ' + Vue.i18n.translate('Unsaved_data_will_be_lost') + '. ' + Vue.i18n.translate('Continue_q'))
                    if (result) {
                        this.onCreateNewAppraisalInvoice()
                    }
                } else {
                    this.onCreateNewAppraisalInvoice()
                }
                */
            },
            duplicateAppraisalInvoice: function (entity) {

                this.master_loading = true

                const new_versionnumber = entity.version + 1

                let filenumber = ''
                filenumber = this.appraisalfile.number

                let s = entity.number + ''
                while (s.length < 2) s = '0' + s
                let invoicenumber = s

                let p = new_versionnumber + ''
                while (p.length < 2) p = '0' + p
                let invoiceversion = p

                let fullnumber = filenumber + '/' + invoicenumber + '/' + invoiceversion

                this.RESET_APPRAISALINVOICE().then((res) => {
                    this.CREATE_NEW_APPRAISALINVOICE({
                        path: 'appraisalinvoices' + '/',
                        parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalinvoices' + '/',
                        file_id: this.appraisalfile.id,
                        number: entity.number,
                        version: new_versionnumber,
                        full_number: fullnumber
                    }).then((res) => {

                        console.log('duplicateAppraisalInvoice then res:')
                        console.log(res)

                        const new_object_id = res.key
                        const new_object_version = new_versionnumber

                        this.GET_APPRAISALINVOICE({path: 'appraisalinvoices' + '/' + entity.id}).then((res) => {

                            console.log(' *^*^*^*^*^*^*^*^*^*^get appraisal invoice res: ')
                            console.log(res)

                            let new_object = res
                            new_object.id = new_object_id
                            new_object.version = new_object_version

                            this.UPDATE_APPRAISALINVOICE({
                                object: new_object,
                                path: 'appraisalinvoices/',
                                parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalinvoices' + '/',
                                key: new_object_id
                            }).then((res) => {

                                this.master_loading = true
                                this.FETCH_APPRAISALFILE_APPRAISALINVOICES({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalinvoices'})
                                    .then(() => {
                                        this.master_loading = false
                                    })

                            })

                        })

                    })
                })

            },
            editAppraisalInvoice: function (entity) {
                this.SET_APPRAISALINVOICE({path: 'appraisalinvoices' + '/' + entity.id}).then((res) => {
                    this.$router.push({
                        name: 'appraisalinvoice-editor',
                        query: {id: entity.id, file_id: this.appraisalfile.id}
                    })
                })
            },
            checkEditAppraisalInvoice: function (entity) {
                if (this.appraisalfile.dirty) {
                    const result = window.confirm(Vue.i18n.translate('There_are_unsaved_changes') + '. ' + Vue.i18n.translate('Unsaved_data_will_be_lost') + '. ' + Vue.i18n.translate('Continue_q'))
                    if (result) {
                        this.editAppraisalInvoice(entity)
                    }
                } else {
                    this.editAppraisalInvoice(entity)
                }
            },
            deleteAppraisalInvoice: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete') + ' ' + Vue.i18n.translate('invoice') + ' "' + entity.file_number + '/' + entity.number + '/' + entity.version + '". ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_APPRAISALINVOICE({
                        file_id: this.appraisalfile.id,
                        path: 'appraisalinvoices' + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalinvoices' + '/' + entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISALFILE_APPRAISALINVOICES({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalinvoices'})
                            .then(() => {
                                this.master_loading = false
                            })
                    })

                }

            },
            onGoBack: function () {
                router.go(-1)
            },
            onGoUp: function () {
                this.$router.push({name: 'appraisalfiles-index'})
            },
            onSaveCurrentAppraisalFile: function (data) {
                console.log('appraisalfile.id: ')
                console.log(this.appraisalfile.id)
                this.UPDATE_APPRAISALFILE({
                    object: this.appraisalfile,
                    path: 'appraisalfiles' + '/' + this.appraisalfile.id
                }).then((res) => {
                    if (data.go_up) {
                        this.onGoUp()
                    }

                })
            },
            editAppraisalReport: function (entity) {
                this.SET_APPRAISALREPORT({path: 'appraisalreports' + '/' + entity.id}).then((res) => {
                    this.$router.push({name: 'appraisalreport-editor', query: {id: entity.id}})
                })
            },
            checkEditAppraisalReport: function (entity) {
                if (this.appraisalfile.dirty) {
                    const result = window.confirm(Vue.i18n.translate('There_are_unsaved_changes') + '. ' + Vue.i18n.translate('Unsaved_data_will_be_lost') + '. ' + Vue.i18n.translate('Continue_q'))
                    if (result) {
                        this.editAppraisalReport(entity)
                    }
                } else {
                    this.editAppraisalReport(entity)
                }
            },
            deleteAppraisalReport: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete') + entity.filenumber + ', ' + entity.filedescription + '. ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_APPRAISALREPORT({
                        file_id: this.appraisalfile.id,
                        path: 'appraisalreports' + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/' + entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISALFILE_APPRAISALREPORTS({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalreports'})
                            .then(() => {
                                this.master_loading = false
                            })
                    })

                }

            },
            editAppraisalQuote: function (entity) {
                this.SET_APPRAISALQUOTE({path: 'appraisalquotes' + '/' + entity.id}).then((res) => {
                    this.$router.push({name: 'appraisalquote-editor', query: {id: entity.id}})
                })
            },
            checkEditAppraisalQuote: function (entity) {
                if (this.appraisalfile.dirty) {
                    const result = window.confirm(Vue.i18n.translate('There_are_unsaved_changes') + '. ' + Vue.i18n.translate('Unsaved_data_will_be_lost') + '. ' + Vue.i18n.translate('Continue_q'))
                    if (result) {
                        this.editAppraisalQuote(entity)
                    }
                } else {
                    this.editAppraisalQuote(entity)
                }
            },
            deleteAppraisalQuote: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete') + entity.filenumber + ', ' + entity.filedescription + '. ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_APPRAISALQUOTE({
                        file_id: this.appraisalfile.id,
                        path: 'appraisalquotes' + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalquotes' + '/' + entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_APPRAISALFILE_APPRAISALQUOTES({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalquotes'})
                            .then(() => {
                                this.master_loading = false
                            })
                    })

                }

            }
        },
        head: {
            title: {
                //inner: Vue.i18n.translate('New_appraisalfile')
                inner: 'Edit Appraisal-File'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// AppraisalFileEditor.vue?35bff20c